export default __webpack_public_path__ + "static/media/goodweM.fdcaa50f.jpg";